// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sensorsChart__qvccS {
  height: 470px !important;
}

.centerText___nZcw {
  font-family: "Roboto", sans-serif !important;
  font-size: 20px !important;
  color: var(--legend-for-header-text);
  font-weight: 500;
  text-align: center;
}

.centerTitle__QXxbe {
  color: var(--tables-secondary-row-sub-title-text);
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.xLabels__bj0QW,
.yLabels__jirYV {
  color: var(--header-icon-secondary);
}

.dataLabel__NCVhK text {
  font-size: 20px !important;
  fill: var(--legend-for-header-text) !important;
  font-weight: 500 !important;
}
.dataLabel__NCVhK tspan {
  stroke: unset;
}

.legendLabel__a1iW9 {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  column-gap: 8px;
  color: var(--title-inputs-sections-title) !important;
  text-transform: uppercase;
  text-box-trim: none;
}

.fullHeight__hUyva {
  min-height: 470px;
  align-items: center;
}

.urgency__TnD7n {
  width: 200px;
  text-align: start !important;
}

.skeleton__pZstq {
  width: 312px;
  height: 312px;
  border-radius: 50%;
  margin-top: 46px;
}

.skeletonSelect___91wY {
  margin-top: 18px;
  height: 35px;
  width: 200px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ExecutiveSummary/components/AssetHealthOverview/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,wBAAA;AAzEF;;AA4EA;EACE,4CAAA;EACA,0BAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,iDAAA;EAEA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA1EF;;AA6EA;;EAEE,mCAAA;AA1EF;;AA8EE;EACE,0BAAA;EACA,8CAAA;EACA,2BAAA;AA3EJ;AA8EE;EACE,aAAA;AA5EJ;;AAgFA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oDAAA;EACA,yBAAA;EACA,mBAAA;AA7EF;;AAgFA;EACE,iBAAA;EACA,mBAAA;AA7EF;;AAgFA;EACE,YAAA;EACA,4BAAA;AA7EF;;AAgFA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AA7EF;;AAgFA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.sensorsChart {\n  height: 470px !important;\n}\n\n.centerText {\n  font-family: 'Roboto', sans-serif !important;\n  font-size: 20px !important;\n  color: var(--legend-for-header-text);\n  font-weight: 500;\n  text-align: center;\n}\n\n.centerTitle {\n  color: var(--tables-secondary-row-sub-title-text);\n\n  font-family: Roboto;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.xLabels,\n.yLabels {\n  color: var(--header-icon-secondary);\n}\n\n.dataLabel {\n  text {\n    font-size: 20px !important;\n    fill: var(--legend-for-header-text) !important;\n    font-weight: 500 !important;\n  }\n\n  tspan {\n    stroke: unset;\n  }\n}\n\n.legendLabel {\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  column-gap: 8px;\n  color: var(--title-inputs-sections-title) !important;\n  text-transform: uppercase;\n  text-box-trim: none;\n}\n\n.fullHeight {\n  min-height: 470px;\n  align-items: center;\n}\n\n.urgency {\n  width: 200px;\n  text-align: start !important;\n}\n\n.skeleton {\n  width: 312px;\n  height: 312px;\n  border-radius: 50%;\n  margin-top: 46px;\n}\n\n.skeletonSelect {\n  margin-top: 18px;\n  height: 35px;\n  width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensorsChart": `sensorsChart__qvccS`,
	"centerText": `centerText___nZcw`,
	"centerTitle": `centerTitle__QXxbe`,
	"xLabels": `xLabels__bj0QW`,
	"yLabels": `yLabels__jirYV`,
	"dataLabel": `dataLabel__NCVhK`,
	"legendLabel": `legendLabel__a1iW9`,
	"fullHeight": `fullHeight__hUyva`,
	"urgency": `urgency__TnD7n`,
	"skeleton": `skeleton__pZstq`,
	"skeletonSelect": `skeletonSelect___91wY`
};
module.exports = ___CSS_LOADER_EXPORT___;
